import React, {Component} from 'react';
import OnClickOutSide from 'react-onclickoutside';
import Radium from 'radium';
import PropTypes from 'prop-types';

import CustomDropDownIcon from 'assets/CustomDropDownIcon';
import {toggleState} from '../../utils/ComponentUtilFunctions';
import './index.css';
import config from "../../config";

const styles = {
    item: {
        paddingLeft: '10px',
        fontSize: '14px',
        textAlign: 'left',
    },
};

class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.toggleState = toggleState.bind(this);
    }

    handleClickOutside = () => {
        this.setState({
            isOpen: false,
        });
    };

    open = () => {
        this.setState({
            isOpen: true,
        });
    };

    handleOptionClick = option => () => {
        const {handleSelect} = this.props;
        handleSelect(option.value);
        this.setState({
            isOpen: false,
        });
    };

    render() {
        const {isOpen} = this.state;
        const {
            height,
            selected,
            title,
            options,
            wrapperStyles,
            listStyles,
            itemHoverColor,
            titleStyles,
            itemStyles,
            position,
        } = this.props;

        const selectedOption = options.find(option => option.value === selected);
        const titleToShow = selectedOption ? selectedOption.title : title;

        const optionsWithoutSelected = options.filter(option => selected !== option.value);

        let topPosition;
        switch (position) {
            case 'top':
                topPosition = -optionsWithoutSelected.length * height;
                break;
            case 'bottom':
                topPosition = height;
                break;
            default:
                topPosition = height;
                break;
        }

        return (
            <div className="custom-select" style={{borderRadius: '10px', height, ...wrapperStyles}}>
                <button
                    type="button"
                    className="no-style-button selected centered-flex-container"
                    style={{
                        height: '100%',
                        width: '100%',
                        padding: 0,
                        justifyContent: 'flex-start',
                    }}
                    onClick={this.toggleState('isOpen')}
                >
                    <p style={[styles.item, {marginRight: '10px', color: '#A4ADC1'}, titleStyles]}>
                        {titleToShow}
                    </p>
                    <CustomDropDownIcon height="5px" width="10px"/>
                </button>
                <ul className={isOpen ? 'list' : 'list closed'}
                    style={{zIndex: '2000', ...{top: topPosition, ...listStyles}}}>
                    {optionsWithoutSelected.map(option => (
                        <li
                            key={option.value}
                            style={[
                                styles.item,
                                {
                                    height,
                                    lineHeight: `${height}px`,
                                    ':hover': option.value === config.rolesMap.owner ? {} : { backgroundColor: itemHoverColor },
                                    opacity: option.value === config.rolesMap.owner ? 0.5 : 1,
                                    cursor: option.value === config.rolesMap.owner ? 'not-allowed' : 'pointer'
                                },
                                itemStyles
                            ]}
                            className="item"
                            onClick={option.value === config.rolesMap.owner ? undefined : this.handleOptionClick(option)}
                        >
                            {option.title}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

Select.propTypes = {
    height: PropTypes.number,
    title: PropTypes.string,
    options: PropTypes.array,
    selected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    handleSelect: PropTypes.func.isRequired,
    wrapperStyles: PropTypes.object,
    listStyles: PropTypes.object,
    itemHoverColor: PropTypes.string,
    titleStyles: PropTypes.object,
    itemStyles: PropTypes.object,
    position: PropTypes.string,
};

Select.defaultProps = {
    title: 'Select',
    options: [
        {
            id: 1,
            title: 'no select options',
        },
    ],
    height: 32,
    selected: null,
    wrapperStyles: {},
    listStyles: {},
    titleStyles: {},
    itemStyles: {},
    itemHoverColor: '#3D568F',
    position: 'bottom',
};

export default OnClickOutSide(Radium(Select));



// WEBPACK FOOTER //
// ./src/components/select/index.jsx